module.exports = "pegasus_template/assets/fruit-bg.jpg";